<template>
  <div class="grid">
    <div class="col-12">
      <h1> Image Gallery</h1>
    </div>
    <div class="col-12">
      <div class="p-fluid formgrid grid" style="margin-top: 2%">
        <div class="field col-12 md:col-3">
          <span class="p-float-label">
            <Dropdown id="state" v-model="user_type_search" :options="user_type_dropdown" optionLabel="name"
              :optionValue="value" filter>
            </Dropdown>
            <label for="type">Select Type</label>
          </span>
        </div>
        <div class="field col-12 md:col-3">
          <span class="p-float-label">
            <Calendar v-model="filter_date" dateFormat="dd-mm-yy" selectionMode="range" :manualInput="false" showIcon iconDisplay="input"
              :numberOfMonths="1" :showTime="false" hourFormat="12" />
            <label>Date</label>
          </span>
        </div>
        <div class="field col-12 md:col-2">
          <Button icon="pi pi-search" @click="get_list()" v-tooltip.bottom="'Search'" />&nbsp;
          <Button icon="pi pi-refresh" @click="reset()" v-tooltip.bottom="'Reset'" />
        </div>
        <div class="field col-12 md:col-3">

        </div>
        <div class="field col-12 md:col-1">
          <b>  Total : {{ images.length }} </b>
        </div>
      </div>
    </div>

    <div class="col-12" style="background-color: #374151;">
      
      <!-- <div class="overflow_cls"> -->
        <ScrollPanel style="width: 100%; height: 500px">
          <loading :active="isLoadingModel" :can-cancel="true" color="#173EA3" :is-full-page="fullPage"></loading>
        <div class="p-fluid formgrid grid">
          <div class="field col-12 md:col-2" v-for="(data, key) in images" :key="key">
            <Image :src="'https://travelsafe-docs.s3.ap-south-1.amazonaws.com/' + data.photo" alt="Image" width="100"
              height="100" preview />
          </div>
        </div>
      <!-- </div> -->
    </ScrollPanel>

    </div>
  </div>
</template>
<script>
import ProductService from '../../service/ProductService';
//import PhotoService from "../../service/PhotoService";
import apis from "@/apis";
export default {
  name: 'UiCodeTrackGallary',
  data() {
    return {
      user_type_search: null,
      user_type_dropdown: [{ name: 'DELIVERY CHALLAN PHOTO UPLOAD', value: 'Delivered' }],
      isLoadingModel: false,
      fullPage: false,
      filter_date: "",
      images: [],
      position: 'top',
      galleriaResponsiveOptions: [
        {
          breakpoint: "1024px",
          numVisible: 5,
        },
        {
          breakpoint: "960px",
          numVisible: 4,
        },
        {
          breakpoint: "768px",
          numVisible: 3,
        },
        {
          breakpoint: "560px",
          numVisible: 1,
        },
      ],
      carouselResponsiveOptions: [
        {
          breakpoint: "1024px",
          numVisible: 3,
          numScroll: 3,
        },
        {
          breakpoint: "768px",
          numVisible: 2,
          numScroll: 2,
        },
        {
          breakpoint: "560px",
          numVisible: 1,
          numScroll: 1,
        },
      ],
    };
  },
  created() {
    this.productService = new ProductService();
    //this.photoService = new PhotoService();
    this.get_list();
  },
  mounted() {
    // this.productService.getProductsSmall().then((products) => {
    //   this.products = products;
    // });
    // this.photoService.getImages().then((images) => {
    //   this.images = images;
    // });
  },
  methods: {
    reset() {
      this.filter_date = "";
      this.get_list();
    },
    get_list() {
      var from_date = "";
      var to_date = "";
      if (this.filter_date) {
        from_date = this.dateFormatYMD(this.filter_date[0]);
        to_date = this.dateFormatYMD(this.filter_date[1]);
      }
      var data = {
        //client_id: localStorage.getItem("client_id")
        "client_id": localStorage.getItem("client_id"),
        "from_date": from_date,
        "to_date": to_date
      };
      this.isLoadingModel = true;
      var promise = apis.GetReceiptPhotos(data);
      promise.then((responseapi) => {
        this.isLoadingModel = false;
        this.images = responseapi.data.data;
      });
    },
    dateFormatYMD(inputDate) {
      var postdate = inputDate;
      if (inputDate) {
        inputDate = new Date(inputDate);
        if (inputDate.toString() == "NaN-NaN-NaN") {
          return postdate;
        } else {
          let date = ("0" + inputDate.getDate()).slice(-2);
          let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);
          let year = inputDate.getFullYear();
          if (date.toString() == "aN") {
            return postdate;
          } else {
            return year + "-" + month + "-" + date;
          }
        }
      } else {
        return "";
      }
    },
    dateFormatDMY(inputDate) {
      var postdate = inputDate;
      if (inputDate) {
        inputDate = new Date(inputDate);
        if (inputDate.toString() == "NaN-NaN-NaN") {
          return postdate;
        } else {
          let date = ("0" + inputDate.getDate()).slice(-2);
          let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);
          let year = inputDate.getFullYear();
          if (date.toString() == "aN") {
            return postdate;
          } else {
            return date + "/" + month + "/" + year;
          }
        }
      } else {
        return "";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.overflow_cls {
  overflow: scroll;
  height: 500px;
}
</style>